import { Component, Input } from '@angular/core';
import { Opportunity } from '@vendasta/sales-opportunities';
import { ReplaySubject } from 'rxjs';
@Component({
  selector: 'sales-ui-opportunity-info',
  templateUrl: './opportunity-info.component.html',
  styleUrls: ['./opportunity-info.component.scss'],
})
export class OpportunityInfoComponent {
  @Input() preferredCurrency: string;
  @Input() set opportunity(opportunity: Opportunity) {
    this.opportunity$$.next(opportunity);
  }
  private readonly opportunity$$ = new ReplaySubject<Opportunity>(1);
  readonly opportunity$ = this.opportunity$$.asObservable();
}
